import {RemotePostAccessManagementPermissions} from 'data/usecases/private/profile/remote-post-access-management-permissions';
import {PostAccessManagementPermissions} from 'domain/usecases/private/profile/post-access-management-permissions';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {AccessManagementEndpoints} from 'main/factories/usecases/endpoints';

export const makePostAccessManagementPermissions = (): PostAccessManagementPermissions =>
	new RemotePostAccessManagementPermissions(
		makeBFFApiUrl(AccessManagementEndpoints.permissions),
		makeAuthorizeHttpClientDecorator(),
	);
